import { findLocalGeoJsonBuilding } from "./use-building";

const mapboxToken =
  "pk.eyJ1IjoibHVrYXNib3pvbnR1a2UiLCJhIjoiY2xxMjg0ZTVwMDFvZjJxcXFyeHY4N2kyZiJ9.sV2EIcZIctuxaDqj3tTtPg";

const initialViewState = {
  longitude: 21.245628049059125,
  latitude: 48.73221587399511,
  zoom: 15,
};

// Function to geocode address and get coordinates
export const geocodeAddress = async (
  address: string
): Promise<[number, number] | null> => {
  // First try to find in local data
  const localCoords = findLocalGeoJsonBuilding(address);
  if (localCoords) {
    console.log("Found in local data:", address, localCoords);
    return localCoords;
  }

  // Fall back to Mapbox geocoding
  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${mapboxToken}&proximity=${initialViewState.longitude},${initialViewState.latitude}&limit=1`
    );
    const data = await response.json();
    if (data.features && data.features.length > 0) {
      return data.features[0].center as [number, number];
    }
    return null;
  } catch (error) {
    console.error("Geocoding error:", error);
    return null;
  }
};

export interface RouteGeoJSON {
  type: "Feature";
  properties: Record<string, unknown>;
  geometry: {
    type: string;
    coordinates: [number, number][];
  };
}

// Function to fetch route from Mapbox Directions API
export const fetchRoute = async (
  fromCoords: [number, number],
  toCoords: [number, number]
): Promise<RouteGeoJSON | null> => {
  try {
    const response = await fetch(
      `https://api.mapbox.com/directions/v5/mapbox/walking/${fromCoords[0]},${fromCoords[1]};${toCoords[0]},${toCoords[1]}?geometries=geojson&access_token=${mapboxToken}`
    );
    const data = await response.json();
    console.log("Route API response:", data);
    if (data.routes && data.routes.length > 0) {
      const route = data.routes[0];
      const routeGeoJSON: RouteGeoJSON = {
        type: "Feature" as const,
        properties: {},
        geometry: route.geometry,
      };
      console.log("Route data:", routeGeoJSON);
      return routeGeoJSON;
    }
    return null;
  } catch (error) {
    console.error("Error fetching route:", error);
    return null;
  }
};
